// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL, URLS } from '../config/config';

export const projectsApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (data) => ({
        url: URLS.login,
        method: 'POST',
        body: data,
      }),
    }),
    createProject: builder.mutation({
      query: (data) => ({
        url: URLS.createProject,
        method: 'POST',
        body: data,
      }),
    }),
    getProjects: builder.query({
      query: () => URLS.getProjects,
    }),
    deleteProject: builder.mutation({
      query: (id) => ({
        url: URLS.deleteProject(id),
        method: 'DELETE',
      }),
    }),
    updateProject: builder.mutation({
      query: ({ id, ...patch }) => {
        return {
          url: URLS.updateProject(id),
          method: 'PATCH',
          body: patch.formData,
        };
      },
    }),
    filterProject: builder.mutation({
      query: (tag) => ({
        url: URLS.filterProject,
        method: 'POST',
        body: { tag },
      }),
    }),
    sendEmail: builder.mutation({
      query: (data) => ({
        url: URLS.sendEmail,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useCreateProjectMutation,
  useGetProjectsQuery,
  useDeleteProjectMutation,
  useUpdateProjectMutation,
  useFilterProjectMutation,
  useSendEmailMutation
} = projectsApi;
